export const MAX_CUSTOMERS = parseInt(process.env.REACT_APP_MAX_CUSTOMERS!)
export const MAX_MEALS = parseInt(process.env.REACT_APP_MAX_MEALS!)
export const MAX_PATTERNS = parseInt(process.env.REACT_APP_MAX_PATTERNS!)
export const MAX_MEAL_WEEKS = parseInt(process.env.REACT_APP_MAX_MEAL_WEEKS!)
export const GREY_PALLETE = ['#DCDCDC','#D3D3D3', '#C0C0C0', '#A9A9A9', '#808080', '#696969', '#778899', '#708090']
export const ACTIVE_PALLETE = ['#D8B5FB','#BEB5EE', '#BEB5EE', '#88B3D0', '#88B3D0', '#52B1B3', '#39B0A5', '#24AE99']